import { ExpenseAreas } from './ExpenseAreas';

export const ManageExpenseAreas = () => {
    return (
        <div className="admin-panel__table-container">
            <ExpenseAreas />
        </div>
    );
};
